var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-container",staticStyle:{"position":"fixed"}},[_c('div',{staticClass:"message-container"},[_vm._v(_vm._s(_vm.message))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container"},[_c('img',{attrs:{"alt":"en attente","src":"/assets/images/spinners/crepe-o.gif"}})])
}]

export { render, staticRenderFns }